<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
    <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
        <div class="col-sm-12 px-0 align-self-end">
          <!-- <div class="row align-items-center">
            <div class="col-sm-10">
              <h5 class="light-header bold">
                {{ 'LANDING.LBL_TITLE' | translate}}
              </h5>
            </div>
          </div>
          <hr class="mt-0 mb-3" /> -->
        </div>
        <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-6">
        <div class="pt-3">
          <!-- <div class="container border rounded p-3 bold"> -->
            <form>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <button type="button" class="btn btn-primary btn-sm" style="font-size: 18px;width: 200px;" (click)="onboradclients = !onboradclients"> Onboard Clients</button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn btn-primary btn-sm" style="font-size: 18px;width: 200px;" (click)="manageMachines()"> Manage Machines</button>
                      </div>
                    </div>
                    <div class="form-row" [hidden] = "!onboradclients">
                      <div class="form-group col-md-6">
                        <button type="button" class="btn btn-primary btn-sm" style="font-size: 14px;width: 200px;" (click)="Clinics()"> Manage Clinics</button>
                      </div>
                    </div>
                    <div class="form-row" [hidden] = "!onboradclients">
                      <div class="form-group col-md-6">
                        <button type="button" class="btn btn-primary btn-sm" style="font-size: 14px;width: 200px;" (click)="Users()"> Manage Users</button>
                      </div>
                    </div>
<!--                    <div class="form-row" [hidden] = "!onboradclients">-->
<!--                      <div class="form-group col-md-6">-->
<!--                        <button type="button" class="btn btn-primary btn-sm" style="font-size: 14px;width: 200px;" (click)="Patients()"> Manage Patients</button>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="form-row" [hidden] = "!onboradclients">-->
<!--                      <div class="form-group col-md-6">-->
<!--                        <button type="button" class="btn btn-primary btn-sm" style="font-size: 14px;width: 200px;" (click)="ImportData()"> Import Data</button>-->
<!--                      </div>-->
<!--                    </div>-->
            </form>
          <!-- </div> -->
        </div>
      </div>
      </div>
    </div>
  </div>
